// ** Kameralar
const initialKameralarState = {}

const CameraStats = (state = initialKameralarState, action) => {
  switch (action.type) {
    case "SET_KAMERALAR_STATS":
      return { ...action.val }
    default:
      return state
  }
}

export default CameraStats
